(function(){
  var hideTimer=null;

  function escHtml(s){return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;")}
  function money(cents){
    if(typeof cents==="string")cents=parseInt(cents,10);
    if(isNaN(cents))return "";
    var v=(cents/100).toFixed(2).replace(".",","),p=v.split(",");
    p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,".");
    return "R$ "+p.join(",");
  }

  function updateCartUI(){
    return fetch("/cart.js",{headers:{Accept:"application/json"}}).then(function(r){return r.json()}).then(function(cart){
      var count=cart.item_count||0;
      document.querySelectorAll("[data-cart-count], cart-count, .cart-count, .cart__count, .header__cart-count, .cart-link__bubble, .cart-link__bubble-num, [data-header-cart-count], .header__icon-count, .header__cart__status").forEach(function(el){
        el.textContent=count;
        if(el.setAttribute)el.setAttribute("data-cart-count",count);
        count>0&&el.classList.add("cart-link__bubble--visible")
      });
      try{document.documentElement.dispatchEvent(new CustomEvent("cart:updated",{detail:{cart:cart},bubbles:!0}))}catch(e){}
      return cart
    })
  }

  function openCartDrawer(){try{document.dispatchEvent(new CustomEvent("theme:cart:refresh",{bubbles:!0}))}catch(e){}}

  function hide(){
    var t=document.querySelector(".pdp-added-toast");
    if(!t)return;
    t.classList.remove("is-visible");
    setTimeout(function(){t.parentNode&&t.parentNode.removeChild(t)},360)
  }

  function mount(html,cls){
    var existing=document.querySelector(".pdp-added-toast");
    existing&&existing.parentNode&&existing.parentNode.removeChild(existing);
    clearTimeout(hideTimer);
    var toast=document.createElement("div");
    toast.className="pdp-added-toast"+(cls?" "+cls:"");
    toast.innerHTML=html;
    document.body.appendChild(toast);
    requestAnimationFrame(function(){toast.classList.add("is-visible")});
    setTimeout(function(){toast.classList.add("is-visible")},30);
    var closeBtn=toast.querySelector(".pdp-added-toast__close");
    closeBtn&&closeBtn.addEventListener("click",hide);
    toast.addEventListener("mouseenter",function(){clearTimeout(hideTimer)});
    toast.addEventListener("mouseleave",function(){hideTimer=setTimeout(hide,1200)});
    return toast;
  }

  var CART_ICON='<svg class="pdp-added-toast__check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';

  function showSuccess(opts){
    opts=opts||{};
    var title=opts.title||"ADICIONADO AO CARRINHO";
    var meta="";
    if(opts.variantTitle&&opts.variantTitle!=="Default Title")meta+='Tamanho<strong>'+escHtml(opts.variantTitle)+"</strong>";
    if(opts.quantity&&opts.quantity>1)meta+=(meta?" &middot; ":"")+"Qtd<strong>"+escHtml(opts.quantity)+"</strong>";
    var html='<div class="pdp-added-toast__header">'+CART_ICON+
      '<span class="pdp-added-toast__title">'+escHtml(title)+'</span>'+
      '<button type="button" class="pdp-added-toast__close" aria-label="Fechar">&times;</button></div>'+
      '<div class="pdp-added-toast__body">'+
      (opts.image?'<div class="pdp-added-toast__image"><img src="'+escHtml(opts.image)+'" alt=""></div>':"")+
      '<div class="pdp-added-toast__info">'+
      '<div><p class="pdp-added-toast__name">'+escHtml(opts.name||"")+"</p>"+
      (meta?'<div class="pdp-added-toast__meta">'+meta+"</div>":"")+"</div>"+
      (opts.price!=null?'<div class="pdp-added-toast__price">'+escHtml(money(opts.price))+"</div>":"")+
      (opts.price!=null?'<div class="pdp-added-toast__installments">4x de '+escHtml(money(Math.round(opts.price/4)))+" sem juros</div>":"")+
      "</div></div>"+
      '<a href="/cart" class="pdp-added-toast__cta">VER CARRINHO</a>';
    mount(html,"");
    hideTimer=setTimeout(hide,2600)
  }

  function showItems(items,title){
    items=items||[];
    if(items.length===1){
      var it=items[0];
      showSuccess({title:title,name:it.product_title||it.title,image:it.image||(it.featured_image&&it.featured_image.url),variantTitle:it.variant_title,quantity:it.quantity,price:it.final_line_price!=null?it.final_line_price:it.final_price});
      return
    }
    var total=0,count=0,thumbs="";
    items.forEach(function(it,i){
      total+=(it.final_line_price!=null?it.final_line_price:(it.final_price||0)*(it.quantity||1));
      count+=it.quantity||1;
      if(i<4&&it.image)thumbs+='<span class="pdp-added-toast__thumb"><img src="'+escHtml(it.image)+'" alt=""></span>'
    });
    if(items.length>4)thumbs+='<span class="pdp-added-toast__thumb pdp-added-toast__thumb--more">+'+(items.length-4)+"</span>";
    var html='<div class="pdp-added-toast__header">'+CART_ICON+
      '<span class="pdp-added-toast__title">'+escHtml(title||"ADICIONADO AO CARRINHO")+'</span>'+
      '<button type="button" class="pdp-added-toast__close" aria-label="Fechar">&times;</button></div>'+
      '<div class="pdp-added-toast__body pdp-added-toast__body--multi">'+
      '<div class="pdp-added-toast__thumbs">'+thumbs+"</div>"+
      '<div class="pdp-added-toast__info">'+
      '<div class="pdp-added-toast__name">'+count+(count>1?" peças adicionadas":" peça adicionada")+"</div>"+
      '<div class="pdp-added-toast__price">'+escHtml(money(total))+"</div>"+
      '<div class="pdp-added-toast__installments">4x de '+escHtml(money(Math.round(total/4)))+" sem juros</div>"+
      "</div></div>"+
      '<a href="/cart" class="pdp-added-toast__cta">VER CARRINHO</a>';
    mount(html,"");
    hideTimer=setTimeout(hide,3200)
  }

  function showToast(opts){
    opts=opts||{};
    if(!opts.error){showSuccess(opts);return}
    var errTitle=opts.errorTitle||"NÃO FOI POSSÍVEL ADICIONAR";
    var html='<div class="pdp-added-toast__header">'+CART_ICON+
      '<span class="pdp-added-toast__title">'+escHtml(errTitle)+'</span>'+
      '<button type="button" class="pdp-added-toast__close" aria-label="Fechar">&times;</button></div>'+
      '<div class="pdp-added-toast__error-msg">'+escHtml(opts.errorMsg||"Tente novamente.")+"</div>";
    mount(html,"pdp-added-toast--error");
    hideTimer=setTimeout(hide,4500)
  }

  function showCart(title){
    return fetch("/cart.js",{headers:{Accept:"application/json"}}).then(function(r){return r.json()}).then(function(cart){
      var it=cart.items&&cart.items[0];
      showSuccess({title:title||"ADICIONADO AO CARRINHO",name:it?it.product_title:"",image:it&&it.image?it.image:null,variantTitle:it?it.variant_title:"",price:cart.total_price});
      return cart
    })
  }

  function isInventoryError(err){
    if(!err)return!1;
    var text=((err.description||"")+" "+(err.message||"")).toLowerCase();
    return /all\s+\d|stock|estoque|cart|carrinho|quantidade|available|dispon|maximum|inventory|sold[\s-]*out/i.test(text)
  }

  function buildInventoryMessage(variantId){
    return fetch("/cart.js",{headers:{Accept:"application/json"}}).then(function(r){return r.json()}).then(function(cart){
      var line=null;
      if(cart&&cart.items)for(var i=0;i<cart.items.length;i++)if(String(cart.items[i].variant_id)===String(variantId)){line=cart.items[i];break}
      if(line&&line.quantity){
        var sizeLabel="";
        line.variant_title&&line.variant_title!=="Default Title"&&(sizeLabel=" (tamanho "+line.variant_title+")");
        return "Você já tem "+line.quantity+" no carrinho"+sizeLabel+" e não há mais estoque disponível."
      }
      return "Não há mais estoque disponível deste item."
    }).catch(function(){return "Não há mais estoque disponível deste item."})
  }

  function closeQuickAddModal(form){
    var dlg=form.closest&&form.closest("dialog.product-quick-add, dialog[data-quick-add-modal]");
    if(!dlg)return;
    var cb=dlg.querySelector("[data-quick-add-modal-close]");
    if(cb){cb.click();return}
    try{typeof dlg.close==="function"&&dlg.close()}catch(e){}
    dlg.removeAttribute("open")
  }

  var lastAddAt=0;
  function pdpSizeMissing(form){
    if(!form.closest||!form.closest("product-component.pdp-live"))return!1;
    var inputs=document.querySelectorAll('.pdp-live__variant--size input[type="radio"]');
    if(!inputs.length)return!1;
    return !document.querySelector('.pdp-live__variant--size input[type="radio"]:checked')
  }
  function askForSize(){
    if(window.atipinaAskForSize){window.atipinaAskForSize();return}
    var b=document.querySelector(".pdp-live__variant--size");
    if(!b)return;
    b.scrollIntoView({behavior:"smooth",block:"center"});
    b.classList.add("pdp-live__variant--needs-pick");
    setTimeout(function(){b.classList.remove("pdp-live__variant--needs-pick")},1600)
  }
  function addToCartFromForm(form){
    var now=(new Date()).getTime();
    if(now-lastAddAt<700)return;
    if(pdpSizeMissing(form)){askForSize();return}
    lastAddAt=now;
    var btn=form.querySelector('[data-add-to-cart], button[type="submit"]'),
        textEl=btn&&btn.querySelector(".btn__text"),
        originalText=textEl?textEl.textContent:btn?btn.textContent:"",
        variantIdField=form.querySelector('[name="id"]'),
        variantId=variantIdField?variantIdField.value:null;
    btn&&(btn.disabled=!0,textEl?textEl.textContent="ADICIONANDO…":btn.textContent="ADICIONANDO…");
    var formData=new FormData(form);
    return fetch("/cart/add.js",{method:"POST",headers:{Accept:"application/json","X-Requested-With":"XMLHttpRequest"},body:formData})
      .then(function(r){return r.ok?r.json():r.json().then(function(err){throw err})})
      .then(function(item){
        return updateCartUI().then(function(){
          btn&&(textEl?textEl.textContent="✓ ADICIONADO":btn.textContent="✓ ADICIONADO",
            setTimeout(function(){textEl?textEl.textContent=originalText||"ADICIONAR AO CARRINHO":btn.textContent=originalText||"ADICIONAR AO CARRINHO";btn.disabled=!1},1800));
          closeQuickAddModal(form);
          showSuccess({name:item.product_title||item.title,image:item.image||(item.featured_image&&item.featured_image.url),variantTitle:item.variant_title,quantity:item.quantity,price:item.final_line_price!=null?item.final_line_price:item.final_price})
        })
      })
      .catch(function(err){
        console.error("Add to cart erro:",err);
        btn&&(textEl?textEl.textContent=originalText||"ADICIONAR AO CARRINHO":btn.textContent=originalText||"ADICIONAR AO CARRINHO",btn.disabled=!1);
        if(isInventoryError(err))buildInventoryMessage(variantId).then(function(msg2){showToast({error:!0,errorTitle:"ESTOQUE LIMITADO",errorMsg:msg2})});
        else{var msg=err&&err.description||err&&err.message||"Tente novamente.";showToast({error:!0,errorMsg:msg})}
      })
  }

  function isHandledForm(form){
    if(!form||form.tagName!=="FORM")return!1;
    var action=(form.getAttribute("action")||"").toLowerCase();
    if(action.indexOf("/cart/add")<0)return!1;
    if(!form.closest)return!1;
    return !!(form.closest("product-component.pdp-live")||form.closest("product-component[data-product-handle]")||form.closest("dialog.product-quick-add")||form.closest("dialog[data-quick-add-modal]"))
  }

  document.addEventListener("submit",function(e){
    var form=e.target;
    if(isHandledForm(form)){
      var ctaBtn=form.querySelector("[data-add-to-cart]");
      if(ctaBtn&&ctaBtn.getAttribute("data-cta-mode")==="notify")return;
      e.preventDefault();e.stopImmediatePropagation();addToCartFromForm(form)
    }
  },!0);

  document.addEventListener("click",function(e){
    if(!e.target||!e.target.closest)return;
    var btn=e.target.closest("[data-add-to-cart], .product__submit__add");
    if(!btn||btn.disabled)return;
    if(btn.getAttribute("data-cta-mode")==="notify")return;
    if(btn.closest("#cart-bar"))return;
    var form=btn.closest("form");
    if(!form||!isHandledForm(form))return;
    e.preventDefault();e.stopImmediatePropagation();addToCartFromForm(form)
  },!0);

  function addFromPdp(){
    var form=document.querySelector('product-component.pdp-live form[action*="/cart/add"]')||document.querySelector('product-component[data-product-handle] form[action*="/cart/add"]');
    if(!form)return!1;
    addToCartFromForm(form);
    return!0
  }

  window.AtipinaToast={show:showToast,showSuccess:showSuccess,showCart:showCart,updateCartUI:updateCartUI,openCartDrawer:openCartDrawer,hide:hide,addForm:addToCartFromForm,addFromPdp:addFromPdp,showItems:showItems}
})();
